import React, { Component } from "react";
import { connect } from "react-redux";
import { switchTableComponent } from "../../actions/ui_actions";
import { ActionButton } from "office-ui-fabric-react/lib/Button";
import { Icon } from "office-ui-fabric-react/lib/Icon";

class TablesSwitchButton extends Component {
  switchToOrderTable = () => {
    this.props.switchTableComponent("order");
  };

  switchToShipmentsTable = () => {
    this.props.switchTableComponent("shipment");
  };

  render() {
    const { componentType } = this.props;

    if (componentType === "toOrder") {
      return (
        <div onClick={this.switchToOrderTable}>
          <Icon
            iconName="NavigateBackMirrored"
            title="Go to orders"
            style={{
              marginTop: "2px",
              color: "blue",
              fontSize: "large",
              cursor: "pointer"
            }}
          />
        </div>
      );
    } else if (componentType === "toShipment") {
      return (
        <div>
          <ActionButton
            text="To shipments"
            iconProps={{
              iconName: "NavigateBack",
              style: { fontSize: "large" }
            }}
            onClick={this.switchToShipmentsTable}
          />
        </div>
      );
    } else return null;
  }
}

export default connect(null, {
  switchTableComponent: switchTableComponent
})(TablesSwitchButton);



// WEBPACK FOOTER //
// ./src/common/Buttons/_TablesSwitchButton.js